import { FormBuilderClient } from '@/components/FormBuilder/FormBuilderClient'
import { useAuth } from '@/lib/auth'
import { getFormDetail } from '@/lib/data-client/forms'
import { primaryFormId } from '@/lib/mock-data'
import { hasFormAdminAccess } from '@/lib/permissions'
import { useQuery } from '@tanstack/react-query'
import { useNavigate, useParams } from '@tanstack/react-router'
import { useEffect } from 'react'

export default function FormBuilderRoute() {
  const params = useParams({ strict: false }) as { formId?: string }
  const navigate = useNavigate()
  const { user, isLoading } = useAuth()
  const canManageForms = hasFormAdminAccess(user)
  const formId = params.formId ?? primaryFormId
  const { data: form, isLoading: isFormLoading } = useQuery({
    queryKey: ['form-detail', formId],
    queryFn: () => getFormDetail(formId),
    enabled: canManageForms,
  })

  useEffect(() => {
    if (!isLoading && !canManageForms) {
      void navigate({ to: '/dashboard/forms' })
    }
  }, [canManageForms, isLoading, navigate])

  if (isLoading || isFormLoading) {
    return <div className="grid min-h-dvh place-items-center text-sm text-slate-500">載入中...</div>
  }

  if (!canManageForms) {
    return (
      <div className="grid min-h-dvh place-items-center bg-slate-50 p-6 text-center">
        <div>
          <h1 className="text-lg font-semibold text-slate-950">沒有編輯權限</h1>
          <p className="mt-2 text-sm text-slate-500">
            你可以返回問卷列表進行分享、預覽或查看客戶清單。
          </p>
        </div>
      </div>
    )
  }

  if (!form) {
    return (
      <div className="grid min-h-dvh place-items-center bg-slate-50 p-6 text-center">
        <div>
          <h1 className="text-lg font-semibold text-slate-950">找不到問卷</h1>
          <p className="mt-2 text-sm text-slate-500">請返回問卷列表重新選擇。</p>
        </div>
      </div>
    )
  }

  return <FormBuilderClient initialForm={form} />
}
